import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-actions-content',
  templateUrl: './form-actions-content.component.html',
  styleUrls: ['./form-actions-content.component.scss']
})
export class FormActionsContentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
